import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CarServices from '../../services/CarServices';
import PostListService from '../../services/PostListServices';
import CategoryServices from '../../services/CategoryServices';
import MembershipServiceListServices from '../../services/MembershipServiceListServices';
import PostList from '../MenuManagment/PostList';
function AddService() {
    const navigate = useNavigate();

    const [formValues, setFormValues] = useState({
        serviceId: '',
        caption: '',
        images: [],
    });
    const [vendors, setVendors] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [previewImages, setPreviewImages] = useState([]);
    const [uploadingImages, setUploadingImages] = useState(false);
    const [services, setServices] = useState([]);
    const [memberships, setMemberships] = useState([]);
    /* ================= CATEGORY ================= */

    useEffect(() => {
        fetchDropdownData();
    }, []);
    const fetchDropdownData = async () => {
        try {
            const serviceRes = await MembershipServiceListServices.getServiceGuest();
            const serviceData = serviceRes?.data || []
            const formattedServices = serviceData
                .filter(item => item.title)
                .map(item => ({
                    _id: item._id,
                    title: item.title
                }));

            setServices(formattedServices);
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
        }
    };

    /* ================= MULTIPLE IMAGES ================= */
    // const handleFileChange = async (e) => {
    //     const files = Array.from(e.target.files);
    //     if (files.length === 0) return;

    //     setUploadingImages(true);
    //     const formData = new FormData();
    //     files.forEach(f => formData.append('images', f));

    //     try {
    //         const res = await MenuServices.createMenu(formData);
    //         if (res.images && res.images.length > 0) {
    //             setFormValues(prev => ({
    //                 ...prev,
    //                 images: [...prev.images, ...res.images]
    //             }));
    //             setPreviewImages(prev => [...prev, ...res.images]);
    //         }
    //     } catch (error) {
    //         console.error('Images upload error:', error);
    //         alert('Failed to upload images');
    //     } finally {
    //         setUploadingImages(false);
    //         e.target.value = '';
    //     }
    // };
    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length === 0) return;

        // store files
        setFormValues(prev => ({
            ...prev,
            images: [...prev.images, ...files]
        }));

        // preview
        const previews = files.map(file => URL.createObjectURL(file));
        setPreviewImages(prev => [...prev, ...previews]);
    };
    /* ================= REMOVE IMAGE ================= */
    const removeImage = (imageToRemove) => {
        setFormValues(prev => ({
            ...prev,
            images: prev.images.filter(img => img !== imageToRemove)
        }));
        setPreviewImages(prev => prev.filter(img => img !== imageToRemove));
    };

    const removeLogo = () => {
        setFormValues(prev => ({ ...prev, logo: '' }));
    };
    /* ================= INPUT ================= */
    const handleInputChange = async (e) => {
        const { name, value } = e.target;
        setFormValues(prev => ({ ...prev, [name]: value }));
    };
    /* ================= SUBMIT ================= */
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formValues.serviceId) {
            alert('Please select a serviceId');
            return;
        }
        if (!formValues.caption) {
            alert('Please enter a Caption');
            return;
        }
        try {
            // const payload = {
            //     serviceId: formValues.serviceId,
            //     caption: formValues.caption,
            //     images: formValues.images
            // };


  const formData = new FormData();

    formData.append("serviceId", formValues.serviceId);
    formData.append("caption", formValues.caption);

    // 🔥 multiple images append
    formValues.images.forEach((img) => {
      formData.append("images", img);
    });


             const res = await PostListService.createPost(formData);
            if (res.status) {
                alert(res.message);
                navigate('/post-list');
            } else {
                alert(res.message || 'Failed to create service');
            }
        } catch (error) {
            console.error('Submit error:', error);
            alert('Error creating service');
        }
    };
    return (
        <div className="right_col">
            <div className="title-box">
                <h2>Add-Post</h2>
                <Link className="list-banner-btn" to="/post-list">Post List</Link>
            </div>
            <div className="container-box px-5">
                <form onSubmit={handleSubmit}>
                    <div className="row">
                        {/* Vendor */}
                        <div className="col-lg-6 mt-3">
                            <div className="input-field">
                                <label>Select Service *</label>
                                <select
                                    name="serviceId"
                                    value={formValues.serviceId}
                                    onChange={handleInputChange}
                                    className="form-control"
                                >
                                    <option value="">Select Service</option>
                                    {services.map(service => (
                                        <option key={service._id} value={service._id}>
                                            {service.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-6 mt-3">
                            <label>Title*</label>
                            <input className="form-control" name="caption"
                                placeholder="Enter Caption"
                                value={formValues.caption}
                                onChange={handleInputChange}  />
                        </div>
                        <div className="col-lg-6 mt-3">
                            <label>Images (Multiple)</label>
                            <input
                                type="file"
                                multiple
                                className="form-control"
                                onChange={handleFileChange}
                                disabled={uploadingImages}
                                accept="image/*"
                            />
                            {uploadingImages && <p className="text-muted mt-1">Uploading images...</p>}

                            {/* Preview Multiple Images */}
                            {previewImages.length > 0 && (
                                <div className="mt-2" style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                    {previewImages.map((img, index) => (
                                        <div key={index} className="position-relative d-inline-block">
                                            <img
                                                // src={`${process.env.REACT_APP_URL}${img}`}
                                                src={img}
                                                width="80"
                                                height="80"
                                                style={{ objectFit: 'cover', borderRadius: '4px' }}
                                                alt={`Preview ${index + 1}`}
                                            />
                                            <button
                                                type="button"
                                                onClick={() => removeImage(img)}
                                                className="btn btn-danger btn-sm"
                                                style={{ position: 'absolute', top: '-8px', right: '-8px', borderRadius: '50%', padding: '2px 6px' }}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* <div className="col-lg-12 mt-3">
                            <label>Description</label>
                            <textarea className="form-control" name="description"
                                placeholder="Description"
                                rows="4"
                                value={formValues.description}
                                onChange={handleInputChange} />
                        </div> */}
                    </div>

                    <button className="submit-green-btn mt-4" type="submit">SUBMIT</button>
                </form>
            </div>
        </div>
    );
}

export default AddService;